class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble-outer');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        const targetElement = this; // Replace with the actual element

        const observer = new MutationObserver(() => {
          if (targetElement.classList.contains('is-empty')) {
            var swiper = new Swiper('#swiper-topseller', {
              slidesPerView: 2,
              spaceBetween: 16,
              observer: true,

              scrollbar: {
                el: '#swiper-topseller .swiper-scrollbar',
                draggable: true,
              },
              navigation: {
                nextEl: '#swiper-topseller .next-btn',
                prevEl: '#swiper-topseller .prev-btn',
              },
            });
          }
        });

        observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });

        if (this.classList.contains('is-empty')) {
          var swiper = new Swiper('#swiper-topseller', {
            slidesPerView: 2,
            spaceBetween: 16,
            observer: true,

            scrollbar: {
              el: '#swiper-topseller .swiper-scrollbar',
              draggable: true,
            },
            navigation: {
              nextEl: '#swiper-topseller .next-btn',
              prevEl: '#swiper-topseller .prev-btn',
            },
          });
        }
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Event listener for external cart addition from wbconnect.de
window.addEventListener('message', function (event) {
  if (event.origin === 'https://ui.pcon-solutions.com') {
    if (typeof event.data.data !== 'undefined' && event.data.data.type === 'sendOCI') {
      const pconLoader = document.querySelector('#pcon-loader');
      if (pconLoader) {
        pconLoader.classList.remove('!od-hidden');
      }
    }
  }

  if (event.origin !== 'https://wbconnect.de') return; // Sicherheit!
  // Show pcon-loader if it exists

  const { variantId } = event.data;
  const { quantity } = event.data;
  const { obxUrl } = event.data;
  const { skus } = event.data;
  const { imageUrl } = event.data;
  console.log('Received message from wbconnect.de:', event.data);

  // Konfigurationsdaten als Line-Item-Properties an die Bestellposition haengen. Nur dort
  // ueberleben sie das Loeschen der Shopify-Wegwerf-Variante: Varianten-Metafelder sterben mit
  // ihr, Properties sind nach dem Add-to-Cart unveraenderlich und Teil der Bestellung.
  // Das '_'-Praefix blendet sie in Warenkorb-/Checkout-Anzeige aus (bestehende Konvention),
  // per Liquid bleiben sie lesbar. Nur setzen, wenn vorhanden - eine aeltere Middleware
  // schickt kein imageUrl mit.
  const properties = {};
  if (imageUrl) properties._pcon_image = imageUrl;
  if (obxUrl) properties._obx_url = obxUrl;

  const cartPayload = { id: variantId, quantity: quantity };
  if (Object.keys(properties).length > 0) cartPayload.properties = properties;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartPayload),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Item added to cart:', data);

      // Use the same approach as cart.js onCartUpdate for cart-drawer-items
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        // Fetch cart drawer content and update like in cart.js
        // Cache-bust + no-store: Shopify section endpoint kann direkt nach cart/add.js
        // einen veralteten Render zurückgeben (kein Title/Image). Forciere frische Response.
        fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
        })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.drawer__footer'];

            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }

            // Update cart drawer state
            cartDrawer.classList.toggle('is-empty', data.item_count === 0);

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'external-wbconnect',
                productVariantId: variantId,
                cartData: data,
              });
            }

            // Initialize swiper for upsells
            if (typeof Swiper !== 'undefined') {
              new Swiper('#swiper-upsells', {
                slidesPerView: 1.3,
                spaceBetween: 16,
                observer: true,
                scrollbar: {
                  el: '.swiper-scrollbar',
                  draggable: true,
                },
                navigation: {
                  nextEl: '.next-btn',
                  prevEl: '.prev-btn',
                },
              });
            }

            // Close product popup modal if it's open before opening cart drawer
            const productPopupModal = document.querySelector('.product-popup-modal');
            if (productPopupModal && productPopupModal.hasAttribute('open')) {
              // Remove open attribute
              productPopupModal.removeAttribute('open');
              // Remove body scroll lock if present
              document.body.classList.remove('overflow-hidden');
              const pconLoader = document.querySelector('#pcon-loader');

              if (pconLoader) {
                pconLoader.classList.add('!od-hidden');
              }

              // Wait a bit for the modal close animation
              setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                  const pconIframe = document.querySelector('#pcon-configurator');
                  if (pconIframe) {
                    const currentSrc = pconIframe.src;
                    pconIframe.src = '';
                    pconIframe.src = currentSrc;
                  }
                }
              }, 200);
            } else {
              // Open the cart drawer immediately if no modal is open
              setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                }
              }, 100);
            }
          })
          .catch((error) => {
            console.error('Error fetching cart drawer content:', error);
          });
      }
    })
    .catch((error) => {
      console.error('Error adding item to cart:', error);
    });
});
